import React, { FC, ReactElement } from "react";
import { cn } from "helpers/style";
import styles from "./SkeletonBlock.module.scss";

type Props = Partial<{
  width: string;
  height: string;
  radius: string;
  circle: boolean;
  className: string;
  style: Record<string, string>;
}>;

const SkeletonBlock: FC<Props> = ({
  width,
  height,
  radius: borderRadius,
  circle,
  className,
  style,
}: Props): ReactElement => {
  return (
    <div
      className={cn([styles.skeleton, circle && styles.circle, className])}
      style={{ maxWidth: width, height, borderRadius, ...style }}
    />
  );
};

export default SkeletonBlock;
